<!-- Center canvas: read-only summary - whole card is one pinnable region -->
<div class="cr-o2p-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-o2p-badge">Only2Photos</span>

  <div class="cr-o2p-grid">
    <div
      class="cr-o2p-dropzone"
      [appInlineMedia]="block.variables?.['FirstImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'FirstImage')"
    >
      <a *ngIf="block.variables?.['FirstImage']; else empty1" [href]="firstImageHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['FirstImage']" [alt]="block.variables?.['FirstImageAlt'] || ''" />
      </a>

      <ng-template #empty1>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div
      class="cr-o2p-dropzone"
      [appInlineMedia]="block.variables?.['SecondImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'SecondImage')"
    >
      <a *ngIf="block.variables?.['SecondImage']; else empty2" [href]="secondImageHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['SecondImage']" [alt]="block.variables?.['SecondImageAlt'] || ''" />
      </a>

      <ng-template #empty2>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - two identical field groups, one per image -->
<div class="cr-o2p-edit" *ngIf="!isPreview">
  <div class="cr-o2p-edit-card">
    <div class="cr-o2p-edit-card-title">First Image</div>

    <div class="cr-o2p-field-row">
      <span class="cr-o2p-field-label">Image</span>
      <span
        class="cr-o2p-toggle"
        [class.cr-o2p-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-o2p-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['FirstImage'] ?? ''"
        (handleOnChange)="onChange($event, 'FirstImage')"
        [placeholder]="firstImagePlaceholder"
        variable="FirstImage"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-o2p-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['FirstImage']">
        <div class="cr-o2p-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-o2p-title">Upload image</div>
        <div class="cr-o2p-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-o2p-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['FirstImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'FirstImageHref')"
        [placeholder]="firstImageHrefPlaceholder"
        variable="FirstImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'FirstImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['FirstImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['FirstImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'FirstImageAlt')"
      [placeholder]="firstImageAltPlaceholder"
      [maxLength]="500"
      variable="FirstImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-o2p-edit-card">
    <div class="cr-o2p-edit-card-title">Second Image</div>

    <div class="cr-o2p-field-row">
      <span class="cr-o2p-field-label">Image</span>
      <span
        class="cr-o2p-toggle"
        [class.cr-o2p-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-o2p-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['SecondImage'] ?? ''"
        (handleOnChange)="onChange($event, 'SecondImage')"
        [placeholder]="secondImagePlaceholder"
        variable="SecondImage"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-o2p-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['SecondImage']">
        <div class="cr-o2p-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-o2p-title">Upload image</div>
        <div class="cr-o2p-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-o2p-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['SecondImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'SecondImageHref')"
        [placeholder]="secondImageHrefPlaceholder"
        variable="SecondImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'SecondImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['SecondImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['SecondImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'SecondImageAlt')"
      [placeholder]="secondImageAltPlaceholder"
      [maxLength]="500"
      variable="SecondImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
